import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class PullRequestService {
  constructor(private http: HttpClient) {}

  public query(params: any) {
    let projectId;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/diff-stats/pull-requests`;

    return this.http.get(url, { params });
  }
}
